import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login     from './pages/Login';
import Dashboard from './pages/Dashboard';
import AuditQueue from './pages/AuditQueue';
import AuditForm  from './pages/AuditForm';
import Completed      from './pages/Completed';
import TechHighlights from './pages/TechHighlights';
import TechStats      from './pages/TechStats';
import Reports    from './pages/Reports';
import Upload     from './pages/Upload';
import Admin      from './pages/Admin';
import Layout     from './components/Layout';

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="queue" element={
              <Protected roles={['admin','auditor']}><AuditQueue /></Protected>
            }/>
            <Route path="audit/:jobId" element={
              <Protected roles={['admin','auditor']}><AuditForm /></Protected>
            }/>
            <Route path="completed"       element={<Completed />} />
            <Route path="tech-highlights" element={<TechHighlights />} />
            <Route path="tech-stats"      element={<TechStats />} />
            <Route path="reports"   element={<Reports />} />
            <Route path="upload"    element={
              <Protected roles={['admin']}><Upload /></Protected>
            }/>
            <Route path="admin"     element={
              <Protected roles={['admin']}><Admin /></Protected>
            }/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
